<template>
  <div class="form-group form-row">
    <div class="col col-sm-4 col-lg-3">
      <div class="col-form-label">
        Status Transitions
      </div>
    </div>
    <div class="col col-sm-8 col-lg-9">
      <div class="form-control-plaintext">
        <router-link
          to="status-transitions"
          append
        >
          <span v-if="total == null">
            Show
          </span>
          <span v-else>
            {{total | formatCount('transition')}}
          </span>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { http } from '@/services/http.js'

export default {
  name: 'ManagePaymentMethodDetailTransitions',
  props: {
    token: String,
    type: String,
    id: String,
  },
  data() {
    return {
      error: null,
      items: null,
      total: null,
    }
  },
  created() {
    this.fetchItems()
  },
  methods: {
    getItems(config) {
      return http.get(`/api/artist-identity/${this.token}/${this.type}/${this.id}/status-transitions/`, config)
    },
    async fetchItems(config) {
      const data = await this.getItems(config)
        .then(response => response.data)
        .catch(err => {
          this.error = err
          throw err
        })
      this.items = data?.data
      this.total = data?.count ?? 0
    },
  },
}
</script>
